import React from "react";
import { useEffect, useState, useRef } from "react";
import { fetchContactList } from "./../../api/chatApi";
import { fetchNewChatSearch } from "./../../api/chatApi";
import { getFormattedDateTime } from "./../../helpers/formatters";
import Avatar from "../Common/Avatar";
import ReactModal from "react-modal";
import OutsideClickHandler from "react-outside-click-handler";
import Scrollbar from "react-scrollbars-custom";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { useCallback } from "react";
import { DebounceInput } from "react-debounce-input";
import { useLayoutEffect } from "react";
import { timeout } from "../../helpers/utilities";
import CheckListBox from "../Common/CheckListBox";
import ChoosePersonsModal from "./ChoosePersonsModal";
import i18n from "./../../i18n";

const LastMesage = ({ item }) => {
  switch (item.lastMessageType) {
    case "TEXT":
      return item.lastMessage;
    case "PHOTO":
      return (
        <>
          <svg
            className="hw-20 text-muted"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
              clipRule="evenodd"
            />
          </svg>
          <p className="text-truncate">ფოტო</p>
        </>
      );
    case "FILE":
      return (
        <>
          <svg
            className="hw-20 text-muted"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
              clipRule="evenodd"
            />
          </svg>
          <p className="text-truncate">ფაილი</p>
        </>
      );
    default:
      return <div dangerouslySetInnerHTML={{ __html: item.lastMessage }} />;
  }
};

const getClass = (item) => {
  let res = item.isGroup ? " groups" : " friends";
  if (item.newMessages > 0) res = `${res} unread`;
  return res;
};

const Sidebar = ({
  getConversationContent,
  selectedContact,
  openConversationModal,
  openConversationItem,
  user,
  newMessage,
  newGroupName,
}) => {
  const [isLoading, setLoading] = useState(true);

  const selectContactItem = selectedContact ? selectedContact : null;

  let contactListScrollbar = useRef(null);
  const [contactList, setContactList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [selectedOption, setSelectedOption] = useState(0);
  const [contactListDropdown, setContactListDropdown] = useState();
  const [prevScroll, setPrevScroll] = useState(0);

  const [anotherCall, setAnotherCall] = useState(false);

  const filterContacts = async (adding = false) => {
    setLoading(true);
    setAnotherCall(false);
    const params = {
      type: selectedOption,
      search: searchValue,
      skip: !adding ? 0 : contactList.length,
    };
    if (!adding) setContactList([]);
    let res = await fetchContactList(params);
    if (!adding) {
      setPrevScroll(0);
      setContactList(res);
      setAnotherCall(res.length > 15);
    } else {
      setContactList([...contactList, ...res]);
      setAnotherCall(res.length > 15);
    }
    setLoading(false);
  };

  const updateScroll = async (pos) => {
    await timeout(20);
    //contactListScrollbar.current.scrollTo(0, pos + 40);
  };

  useLayoutEffect(() => {
    if (prevScroll && contactList.length) {
      //console.log('scscscscscscs', contactListScrollbar)
      //contactListScrollbar.current.scrollTo(0,prevScroll)
      updateScroll(prevScroll);
    }
  }, [contactList, searchValue]);

  useEffect(() => {
    filterContacts();
  }, [selectedOption, searchValue]);

  useEffect(() => {
    if (selectedContact === undefined) filterContacts();
  }, [selectedContact]);

  useEffect(() => {
    if (newMessage && newMessage.id !== user.id) {
      let item = contactList.find(
        (c) => c.id === newMessage.senderId && c.isGroup === newMessage.isGroup
      );
      if (!item)
        setContactList([
          {
            id: newMessage.senderId,
            name: newMessage.name,
            isGroup: !!newMessage.groupId,
            newMessages: 1,
            lastMessage: newMessage.messageText,
            lastMessageDateTime: newMessage.messageSendDate,
            avatar: newMessage.avatar,
          },
          ...contactList,
        ]);
      else {
        if (selectedContact !== newMessage.senderId) item.newMessages++;
        item.lastMessage = newMessage.messageText;
        item.lastMessageDateTime = newMessage.messageSendDate;
        setContactList([...contactList]);
      }
    } else if (newMessage && newMessage.id === user.id && selectedContact) {
      let item = contactList.find((c) => c.id === selectedContact);
      item.lastMessage = newMessage.messageText;
      item.lastMessageDateTime = newMessage.messageSendDate;
      setContactList([...contactList]);
    }
  }, [newMessage]);

  useEffect(() => {
    if (newGroupName) {
      let item = contactList.find((c) => c.id === selectedContact);
      item.name = newGroupName;
      setContactList([...contactList]);
    }
  }, [newGroupName]);

  useEffect(() => {
    if (openConversationItem) {
      if (
        openConversationItem &&
        contactList.every((c) => c.id !== openConversationItem.id)
      )
        setContactList([openConversationItem, ...contactList]);
      else {
        let ind = contactList.findIndex(
          (c) => c.id === openConversationItem.id
        );
        let item = contactList.find((c) => c.id === openConversationItem.id);
        contactList.splice(ind, 1);
        setContactList([item, ...contactList]);
      }
      setPrevScroll(0);
      setTimeout(() => {
        contactListScrollbar.current.scrollToTop();
      }, 30);
    }
  }, [openConversationItem]);

  //onScroll update
  const onUpdateContactListScrollbar = () => {
    //console.log('scccccccc',contactListScrollbar.scrollValues.scrollTop);
    if (
      contactListScrollbar.current.scrollValues.clientHeight +
        contactListScrollbar.current.scrollValues.scrollTop ===
      contactListScrollbar.current.scrollValues.contentScrollHeight
    ) {
      if (anotherCall) {
        setPrevScroll(contactListScrollbar.current.scrollValues.scrollTop);
        filterContacts(true);
      }
    }
  };

  //Modal

  //Contact list filter dropdown

  const toggleContactListDropdown = () => {
    setContactListDropdown(!contactListDropdown);
  };

  let filterDropDownList = [
    { id: 0, label: i18n.t("all") },
    { id: 1, label: i18n.t("unread") },
    { id: 2, label: i18n.t("group.chat") },
  ];

  const onOptionClicked = (id) => () => {
    if (id === selectedOption) filterContacts();
    setSelectedOption(id);
    setContactListDropdown(!contactListDropdown);
  };

  return (
    <>
      <aside className="sidebar">
        <div className="tab-content">
          <div className="tab-pane active" id="chats-content">
            <div className="d-flex flex-column h-100">
              <div className="hide-scrollbar h-100" id="chatContactsList">
                <Scrollbar
                  onUpdate={() => onUpdateContactListScrollbar()}
                  // ref={(c) => {
                  //   contactListScrollbar = c;
                  // }}
                  ref={contactListScrollbar}
                >
                  <div className="sidebar-header sticky-top p-2 hide-title">
                    <div className="d-flex justify-content-between align-items-center">
                      <h5 className=" mb-0">{i18n.t("messages")}</h5>
                      <ul className="nav flex-nowrap">
                        <li className="nav-item list-inline-item mr-0">
                          <div className="dropdown createNewChat-dropdown">
                            <div
                              className="nav-link px-1 create-newChat-btn"
                              onClick={openConversationModal}
                            >
                              <span className="material-icons">create</span>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="sidebar-sub-header">
                      <OutsideClickHandler
                        onOutsideClick={() => {
                          setContactListDropdown(false);
                        }}
                      >
                        <div className="dropdown mr-2 contact-list-filter">
                          <button
                            className="btn btn-outline-default dropdown-toggle"
                            type="button"
                            onClick={toggleContactListDropdown}
                          >
                            {
                              filterDropDownList.find(
                                (i) => i.id === selectedOption
                              ).label
                            }
                          </button>

                          <div
                            className={
                              contactListDropdown
                                ? "dropdown-menu show"
                                : "dropdown-menu"
                            }
                          >
                            {filterDropDownList &&
                              filterDropDownList.map((option, id) => (
                                <div
                                  className="dropdown-item"
                                  key={id}
                                  onClick={onOptionClicked(option.id)}
                                >
                                  {option.label}
                                </div>
                              ))}
                          </div>
                        </div>
                      </OutsideClickHandler>

                      <form className="form-inline">
                        <div className="input-group">
                          <DebounceInput
                            minLength={3}
                            debounceTimeout={1000}
                            placeholder={i18n.t("search")}
                            className="form-control search border-right-0 transparent-bg pr-0"
                            value={searchValue}
                            onChange={(event) =>
                              setSearchValue(event.target.value)
                            }
                          />
                          <div className="input-group-append">
                            <div
                              className="input-group-text transparent-bg border-left-0"
                              role="button"
                            >
                              <svg
                                className="text-muted hw-20"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>

                  <ul
                    className={
                      contactList.length > 10
                        ? "contacts-list changeWidth"
                        : "contacts-list"
                    }
                  >
                    {isLoading && !(contactList && contactList.length > 0)
                      ? [0, 1, 2, 3, 4].map((item, id) => (
                          <li
                            className="contacts-item  friends isLoading"
                            key={id}
                          >
                            <div className="contacts-link">
                              <div className="avatar avatar-offline"></div>
                              <div className="contacts-content">
                                <div className="contacts-info">
                                  <h6 className="chat-name text-truncate"></h6>
                                  <div className="chat-time"> </div>
                                </div>
                                <div className="contacts-texts">
                                  <p className="text-truncate"></p>
                                </div>
                              </div>
                            </div>
                          </li>
                        ))
                      : contactList.map((item, id) => (
                          <li
                            className={`contacts-item ${getClass(item)} ${
                              selectContactItem === item.id ? "active" : ""
                            }`}
                            key={id}
                            onClick={() => {
                              item.newMessages = 0;
                              setContactList([...contactList]);
                              getConversationContent(
                                item.id,
                                item.isGroup,
                                false,
                                item.name,
                                item.avatar
                              );
                            }}
                          >
                            <div className="contacts-link">
                              <Avatar
                                id={item.id}
                                status={item.status}
                                isGroup={item.isGroup}
                                imgPath={item.avatar}
                              />
                              <div className="contacts-content">
                                <div className="contacts-info">
                                  <h6 className="chat-name text-truncate">
                                    {item.name}
                                  </h6>
                                  <div className="chat-time">
                                    {!!item.lastMessageDateTime &&
                                      getFormattedDateTime(
                                        item.lastMessageDateTime,
                                        true
                                      )}
                                  </div>
                                </div>
                                <div className="contacts-texts">
                                  <div className="text-truncate">
                                    <LastMesage item={item} />
                                  </div>
                                  {item.newMessages > 0 && (
                                    <div className="badge badge-rounded badge-primary ml-1">
                                      {item.newMessages}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </li>
                        ))}
                  </ul>
                </Scrollbar>
              </div>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
